module.exports = __webpack_public_path__ + "static/media/2DGACM7.70df9e63.jpg";